import { C } from '../styles/tokens';
import { Ico } from './ui/Icons';

// `nav` is the feature path appended after /organisation/:org/integration/:id/.
// Tools without a route yet are marked `soon` and render non-interactive.
// `tool` is the canonical analytics key for the tile (see Dashboard - Tool Clicked).
const TOOLS = [
  { label: 'Voices',         desc: '900+ voices',         icon: 'mic',     accent: '#2563EB', tint: '#EFF6FF', nav: 'voice',          tool: 'voices' },
  { label: 'Dubbing',        desc: '30+ languages',       icon: 'globe',   accent: '#7C3AED', tint: '#F5F3FF', nav: 'dubbing',        tool: 'dubbing', badge: 'New' },
  { label: 'Studio',         desc: 'Voiceover editor',    icon: 'edit',    accent: '#0EA5E9', tint: '#F0F9FF', nav: 'content',        tool: 'studio' },
  { label: 'Sound Effects',  desc: 'AI SFX library',      icon: 'bolt',    accent: '#D97706', tint: '#FFFBEB', nav: 'sound-effects',  tool: 'sound_effects' },
  { label: 'Music',          desc: 'AI background music', icon: 'music',   accent: '#DB2777', tint: '#FDF2F8', nav: 'music',          tool: 'music' },
  { label: 'Voice Changer',  desc: 'Real-time modulation',icon: 'refresh', accent: '#0891B2', tint: '#ECFEFF', nav: 'voice-changer',  tool: 'voice_changer', badge: 'New' },
  { label: 'Voice Isolator', desc: 'Isolate clean voice', icon: 'mic',     accent: '#16A34A', tint: '#F0FDF4', nav: 'voice-isolator', tool: 'voice_isolator', badge: 'New' },
];

export default function AllToolsGrid({ onToolClick }) {
  return (
    <div style={{ marginBottom: 44 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2 style={{ fontSize: 20, fontWeight: 800, color: C.n900, letterSpacing: '-.01em', margin: 0 }}>All tools</h2>
        <span style={{ fontSize: 12.5, color: C.n400 }}>Browse everything Listen2It can do</span>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
        gap: 12,
      }}>
        {TOOLS.map((tool, i) => (
          <button key={i}
            onClick={() => { if (!tool.soon && tool.nav) onToolClick?.(tool); }}
            style={{
              display: 'flex', alignItems: 'flex-start', gap: 12, padding: '14px 14px',
              background: C.w, border: `1px solid ${C.n200}`, borderRadius: 12,
              cursor: tool.soon ? 'default' : 'pointer', textAlign: 'left',
              transition: 'border-color .12s, transform .12s, box-shadow .12s',
              position: 'relative', minWidth: 0, width: '100%', boxSizing: 'border-box',
              opacity: tool.soon ? 0.85 : 1,
            }}
            onMouseEnter={e => { if (tool.soon) return; e.currentTarget.style.borderColor = tool.accent; e.currentTarget.style.boxShadow = '0 6px 16px rgba(15,23,42,.06)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = C.n200; e.currentTarget.style.boxShadow = ''; e.currentTarget.style.transform = ''; }}>
            <div style={{ width: 42, height: 42, borderRadius: 11, background: tool.tint, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <Ico n={tool.icon} size={19} color={tool.accent} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 5, marginBottom: 2 }}>
                <span style={{ fontSize: 14, fontWeight: 700, color: C.n900, letterSpacing: '-.005em', wordBreak: 'break-word' }}>{tool.label}</span>
                {tool.badge === 'New' && (
                  <span style={{ background: C.n900, color: C.w, borderRadius: 4, fontSize: 8.5, fontWeight: 800, padding: '1px 4px', letterSpacing: '.04em' }}>NEW</span>
                )}
                {tool.soon && (
                  <span style={{ background: '#FEF3C7', color: '#D97706', borderRadius: 4, fontSize: 8.5, fontWeight: 800, padding: '1px 4px', letterSpacing: '.04em' }}>SOON</span>
                )}
              </div>
              <div style={{ fontSize: 11.5, color: C.n500, lineHeight: 1.3, wordBreak: 'break-word' }}>{tool.desc}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
